import { Button, Col, Row } from 'antd'
import useHook, { Props } from './hooks'
import { Link } from 'react-router-dom'
import style from './style.module.scss'

export default function OrderInfo(props: Props) {
  const { infoObj } = useHook(props)
  return (
    <div className={style['container']}>
      <Row justify="space-between">
        <Col span={18}>
          <div className={style['item-container']}>
            <div
              className={style['item-label']}
              style={{ fontSize: '20px', fontWeight: 600 }}
            >
              采购订单号:
            </div>
            <div
              className={style['item-content']}
              style={{ fontSize: '20px', fontWeight: 600 }}
            >
              {infoObj.code}
            </div>
          </div>
        </Col>
        <Col span={2}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>
              <Button>
                <Link
                  to={`/srm/ordersupplierdetail?id=${infoObj.supplierOrderId}`}
                >
                  查看详情
                </Link>
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>创建时间:</div>
                <div className={style['item-content']}>
                  {infoObj.orderCreateTime}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单状态:</div>
                <div className={style['item-content']}>
                  {infoObj.orderStateToName}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购组织:</div>
                <div className={style['item-content']}>{infoObj.groupName}</div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>入库进度:</div>
                <div className={style['item-content']}>
                  {infoObj.warehousingProgress}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购员:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.purchaseMan}{' '}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>是否厂直发:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.directShipment ? '是' : '否'}{' '}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单金额:</div>
                <div className={style['item-content']}>{infoObj.price}</div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>收件人:</div>
                <div className={style['item-content']}>
                  {infoObj.receiveMan}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>退货/取消金额:</div>
                <div className={style['item-content']}>
                  {infoObj.cancelReturnPrice}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>联系方式:</div>
                <div className={style['item-content']}>
                  {infoObj.receiveMobile}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}> 最终结算金额: </div>
                <div className={style['item-content']}>
                  {typeof infoObj.finalPrice === 'number' ? (
                    <span style={{ color: 'green' }}>{infoObj.finalPrice}</span>
                  ) : (
                    '待订单完成后计算'
                  )}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>收件地址:</div>
                <div className={style['item-content']}>{infoObj.address}</div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}
import { Button, Col, Row } from 'antd'
import useHook, { Props } from './hooks'
import { Link } from 'react-router-dom'
import style from './style.module.scss'

export default function OrderInfo(props: Props) {
  const { infoObj } = useHook(props)
  return (
    <div className={style['container']}>
      <Row justify="space-between">
        <Col span={18}>
          <div className={style['item-container']}>
            <div
              className={style['item-label']}
              style={{ fontSize: '20px', fontWeight: 600 }}
            >
              采购订单号:
            </div>
            <div
              className={style['item-content']}
              style={{ fontSize: '20px', fontWeight: 600 }}
            >
              {infoObj.code}
            </div>
          </div>
        </Col>
        <Col span={2}>
          <div className={style['item-container']}>
            <div className={style['item-label']}>
              <Button>
                <Link
                  to={`/srm/ordersupplierdetail?id=${infoObj.supplierOrderId}`}
                >
                  查看详情
                </Link>
              </Button>
            </div>
          </div>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>创建时间:</div>
                <div className={style['item-content']}>
                  {infoObj.orderCreateTime}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单状态:</div>
                <div className={style['item-content']}>
                  {infoObj.orderStateToName}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购组织:</div>
                <div className={style['item-content']}>{infoObj.groupName}</div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>入库进度:</div>
                <div className={style['item-content']}>
                  {infoObj.warehousingProgress}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>采购员:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.purchaseMan}{' '}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>是否厂直发:</div>
                <div className={style['item-content']}>
                  {' '}
                  {infoObj.directShipment ? '是' : '否'}{' '}
                </div>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={12}>
          <Row>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>订单金额:</div>
                <div className={style['item-content']}>{infoObj.price}</div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>收件人:</div>
                <div className={style['item-content']}>
                  {infoObj.receiveMan}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>退货/取消金额:</div>
                <div className={style['item-content']}>
                  {infoObj.cancelReturnPrice}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>联系方式:</div>
                <div className={style['item-content']}>
                  {infoObj.receiveMobile}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}> 最终结算金额: </div>
                <div className={style['item-content']}>
                  {typeof infoObj.finalPrice === 'number' ? (
                    <span style={{ color: 'green' }}>{infoObj.finalPrice}</span>
                  ) : (
                    '待订单完成后计算'
                  )}
                </div>
              </div>
            </Col>
            <Col span={12}>
              <div className={style['item-container']}>
                <div className={style['item-label']}>收件地址:</div>
                <div className={style['item-content']}>{infoObj.address}</div>
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}
